import { DateString, dateStringSerializer, Uuid, uuidSerializer } from "@legacy-megarax/common";
import { MSerializers } from "@legacy-megarax/serializers";
import Decimal from "decimal.js";

import { currencies, Currency, Gtin, gtinSerializer } from "../common";

export type OrderDto = {
  uuid: Uuid;
  referenceNumber: string;
  sellToCustomerUuid: Uuid | null;
  billToCustomerUuid: Uuid | null;
  lines: OrderLineDto[];
  currency: Currency;
  orderDate: DateString;
  netTotal: Decimal;
  updatedAt: Date;
  createdAt: Date;

  placedByUserId: number | null;
};

export type OrderLineDto = {
  uuid: Uuid;
  tradeItemUuid: Uuid;
  tradeItemGtin: Gtin | null;
  tradeItemName: string | null;
  quantity: Decimal;
  price: Decimal;
};

export const orderLineDtoSerializer = MSerializers.object<OrderLineDto>({
  price: MSerializers.decimal,
  quantity: MSerializers.decimal,
  tradeItemUuid: uuidSerializer,
  uuid: uuidSerializer,
  tradeItemGtin: gtinSerializer.nullable(),
  tradeItemName: MSerializers.string.nullable(),
});

export const orderDtoSerializer = MSerializers.object<OrderDto>({
  uuid: uuidSerializer,
  referenceNumber: MSerializers.string,
  sellToCustomerUuid: uuidSerializer.nullable(),
  billToCustomerUuid: uuidSerializer.nullable(),
  lines: MSerializers.array(orderLineDtoSerializer),
  currency: MSerializers.stringOneOf(...currencies),
  netTotal: MSerializers.decimal,
  orderDate: dateStringSerializer,
  updatedAt: MSerializers.datetime,
  createdAt: MSerializers.datetime,
  placedByUserId: MSerializers.integer.nullable(),
});
